// extracted by mini-css-extract-plugin
export default {"loader-box":"loader_loader-box__F9F2B","loader":"loader_loader__C4mIb","l2":"loader_l2__Asyi4"};